import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { ButtonModule, DynamicDialogConfig, DynamicDialogRef } from '@sym-ui/toolkit';
import { PolicyType } from '@casb/constants';
import {
  UsedByDis,
  UsedByPatterns,
  UsedByPolicies,
  UsedByProfiles,
} from '../../_interfaces/used-by';

@Component({
  selector: 'casb-protect-policy-list-dialog',
  imports: [ButtonModule],
  templateUrl: './policy-list-dialog.component.html',
  styleUrl: './policy-list-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PolicyListDialogComponent implements OnInit {
  readonly config = inject(DynamicDialogConfig);
  readonly ref = inject(DynamicDialogRef);

  policyUsage: UsedByPolicies[];
  profileUsage: UsedByProfiles[];
  diUsage: UsedByDis[];
  patternUsage: UsedByPatterns[];
  responseUsage: UsedByPatterns[];
  editDisabled: boolean = false;

  angularPolicies: string[] = [
    PolicyType.DLP_ENDPOINT,
    PolicyType.EMAIL,
    PolicyType.GENERIC_REST,
    PolicyType.WSS,
    PolicyType.DDS_REST,
  ].map((p) => p.toString());

  ngOnInit(): void {
    this.policyUsage = this.config.data['policyData'] || [];
    this.profileUsage = this.config.data['profileData'] || [];
    this.diUsage = this.config.data['diData'] || [];
    this.patternUsage = this.config.data['patternData'] || [];
    this.responseUsage = this.config.data['responseData'] || [];
    this.editDisabled = this.config.data['editDisabled'];
  }

  getPolicyLink(policy: UsedByPolicies): string {
    if (this.angularPolicies.includes(policy.policyType)) {
      return `protect/policies/manage/edit/${encodeURIComponent(policy.policyType)}/${encodeURIComponent(policy.policyName)}`;
    } else if (
      policy.policyType === PolicyType.DSPM ||
      policy.policyType === PolicyType.UNIFIED_POLICY ||
      policy.policyType === PolicyType.ZTNA_POLICY ||
      policy.policyType === PolicyType.WEB_ISO_POLICY ||
      policy.policyType === PolicyType.DLP_SECURLET_POLICY ||
      policy.policyType === PolicyType.DLP_GATELET_POLICY ||
      policy.policyType === PolicyType.DDS_ICAP
    ) {
      return `protect/policies/manage/edit/${encodeURIComponent(policy.policyType)}/${encodeURIComponent(policy.policyId)}`;
    } else {
      // For policy_name, encodeValueForUrl() in appUtilService does the encode before the btoa
      // but it still needs to be encoded again to remove symbols from the b64 for the url
      return (
        'static/ng/appControls/index.html#/manage-policy?' +
        `policy_name=${encodeURIComponent(btoa(encodeURIComponent(policy.policyName)))}` +
        `&policy_type=${encodeURIComponent(btoa(policy.policyType))}`
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getProfileLink(profile: UsedByProfiles): string {
    return `protect/dlpprofiles/manage/${profile.profileId}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getDiLink(di: UsedByDis): string {
    return `protect/dlpprofiles/dataidentifiers/manage/${di.dataIdentifierId}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getResponseLink(response: UsedByPatterns): string {
    return `protect/dlpprofiles/reusable/manage/response/${response.patternId}`;
  }

  onCancel() {
    this.ref.close();
  }
}
